<template>
  <div style="margin: 10px">
    <div style="width: 30%; height: 500px; float: left">
      <vxe-table
        height="100%"
        row-id="id"
        resizable
        highlight-current-row
        ref="xTable"
        :radio-config="{ labelField: 'name', trigger: 'row' }"
        :data="tableData"
        :loading="loading"
        @radio-change="sel"
      >
        <vxe-table-column type="radio" tree-node>
          <template v-slot:header>流程名称</template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div style="width: 70%; float: right; height: 100%">
      <template>
        <v-card title="流程维护">
          <div class="grid-demo">
            <v-form slot="form">
              <v-row :gutter="24">
                <v-col class="gutter-row" span="24">
                  <div class="gutter-box">
                    <v-form-item label="　　流程名称">
                      <v-input
                        placeholder="流程名称"
                        v-model="aa.lcmc"
                      ></v-input>
                    </v-form-item>
                  </div>
                </v-col>
              </v-row>
              <v-row :gutter="24">
                <v-col class="gutter-row" span="24">
                  <div class="gutter-box">
                    <v-form-item label="　　休假类型">
                      <v-select
                        style="width: 150px"
                        :data="xjlx_options"
                        v-model="aa.xjlx"
                        multiple
                      ></v-select>
                    </v-form-item>
                  </div>
                </v-col>
              </v-row>
              <!-- <v-row :gutter="24">
                <v-col class="gutter-row" span="24">
                  <div class="gutter-box">
                    <v-form-item label="流程类型">
                      <v-radio-group @change="change" v-model="aa.state" :data="state_options"></v-radio-group>
                    </v-form-item>
                  </div>
                </v-col>
              </v-row> -->
              <v-row :gutter="24">
                <v-col class="gutter-row" span="24">
                  <div class="gutter-box">
                    <v-form-item label="　　适用客户">
                      <v-select
                        style="width: 150px"
                        :data="sykh_options"
                        v-model="aa.sykh"
                        @change="init"
                      ></v-select>
                    </v-form-item>
                  </div>
                </v-col>
              </v-row>
              <v-row :gutter="24">
                <v-col class="gutter-row" span="24">
                  <div class="gutter-box">
                    <v-form-item label="　　　　地区">
                      <v-select
                        style="width: 150px"
                        :data="dq_options"
                        v-model="aa.dq"
                        @change="init_dq"
                      ></v-select>
                    </v-form-item>
                  </div>
                </v-col>
              </v-row>
              <v-row :gutter="24">
                <v-col class="gutter-row" span="24">
                  <div class="gutter-box">
                    <v-form-item label="　　　　分组">
                      <v-select
                        style="width: 150px"
                        :data="fz_options"
                        v-model="aa.fz"
                        @change="init_fz"
                      ></v-select>
                    </v-form-item>
                  </div>
                </v-col>
              </v-row>
              <v-row :gutter="24">
                <v-col class="gutter-row" span="24">
                  <div class="gutter-box">
                    <v-form-item label="　审批环节数">
                      <v-input
                        placeholder="审批环节数"
                        v-model="aa.sphj"
                        @blur="sphj()"
                      ></v-input>
                    </v-form-item>
                  </div>
                </v-col>
              </v-row>
              <v-row :gutter="24">
                <v-col class="gutter-row" span="24">
                  <div class="gutter-box">
                    <v-form-item label="启用">
                      <v-switch v-model="aa.xy_bz"></v-switch>
                    </v-form-item>
                  </div>
                </v-col>
              </v-row>
            </v-form>
            <div style="text-align: center">
              <v-button type="success" icon="save" @click.prevent="save()"
                >保存</v-button
              >
              <v-button type="primary" icon="reload" @click.prevent="reset()"
                >清空</v-button
              >
            </div>
          </div>
          <br />
          <vxe-grid
            v-bind="xGridOptions"
            size="mini"
            ref="xGrid"
            border
            show-overflow
            :data="tableData2"
            :edit-config="{
              trigger: 'click',
              mode: 'row',
              activeMethod: activeCellMethod,
            }"
            @edit-disabled="editDisabledEvent"
          >
            <template v-slot:empty>
              <span style="color: red">
                <p>未搜索到结果！</p>
              </span>
            </template>
          </vxe-grid>
        </v-card>
      </template>
    </div>
  </div>
</template>

<script>
let aa = {
  lcmc: "",
  xjlx: [],
  sykh: "",
  sphj: "1",
  xy_bz: true,
  spbz: [],
  id: "",
  state: "2",
  dq: "",
  fz: "",
};
export default {
  data: () => ({
    aa,
    loading: false,
    state_options: [
      { text: "通用", value: "1" },
      { text: "特殊", value: "2" },
    ],
    showGroup: false,
    tableData: [],
    tableData2: [],
    dq_options: [],
    fz_options: [],
    sykh_options: [],
    xjlx_options: [],
    xGridOptions: {
      resizable: true,
      height: 408,
      headerAlign: "center",
      columns: [
        {
          type: "seq",
          title: "序号",
          width: 70,
          align: "center",
        },
        {
          field: "spbz_mc",
          title: "审批步骤名称",
          align: "center",
          editRender: { name: "input" },
        },
        {
          field: "sp_js",
          title: "审批人员",
          align: "center",
          editRender: {
            name: "$select",
            options: [],
          },
        },
      ],
    },
  }),
  created() {
    // this.$axios.get("api/system/bxkm/get-bxkm-list").then((res) => {
    //   this.tableData2 = res.data;
    // });
    this.init_sykh();
    this.init_xjlx();
    //this.init_spjs();
    this.init_tree();
    this.sphj();
  },
  mounted() {},
  methods: {
    init_sykh: function () {
      this.$axios.get("api/system/lcsz/get-lcsz-khbh").then((res) => {
        let self = this;
        self.sykh_options = res.data.map((item) => {
          return { value: item.khbh, label: item.khmc };
        });
      });
    },
    init_xjlx: function () {
      this.$axios.get("api/system/lcsz/get-lcsz-xjlx").then((res) => {
        let self = this;
        self.xjlx_options = res.data.map((item) => {
          this.aa.xjlx.push(item.xjlx_dm);
          return { value: item.xjlx_dm, label: item.xjlx_mc };
        });
      });
    },
    init_spjs: function () {
      this.$axios
        .get(
          "api/system/lcsz/get-lcsz-spry?kh=" +
            this.aa.sykh +
            "&dq=" +
            this.aa.dq +
            "&fz=" +
            this.aa.fz
        )
        .then((res) => {
          const column = this.$refs.xGrid.getColumnByField("sp_js");
          column.editRender.options = res.data.map((item) => {
            return { value: item.gh, label: item.xm };
          });
        });
    },
    init: function () {
      this.$axios
        .get("api/system/xjcx/get-xjcx-khdq?khbh=" + aa.sykh)
        .then((res) => {
          let self = this;
          if (res.data.code == 200) {
            let self = this;
            self.dq_options = res.data.data.map((item) => {
              return { value: item.dqdm, label: item.mc };
            });
          } else {
            this.$message["error"](res.data.message);
          }
        });
      if (this.aa.id) {
        this.init_spjs();
      } else {
        this.init_spjs();
        this.sphj();
      }
      this.init_dq();
    },
    init_dq: function () {
      this.$axios
        .get("api/system/xjcx/get-xjcx-fz?khbh=" + aa.sykh + "&khdq=" + aa.dq)
        .then((res) => {
          let self = this;
          if (res.data.code == 200) {
            let self = this;
            self.fz_options = res.data.data.map((item) => {
              return { value: item.fzmc, label: item.fzmc };
            });
          } else {
            this.$message["error"](res.data.message);
          }
        });
      if (this.aa.id) {
        this.init_spjs();
      } else {
        this.init_spjs();
        this.sphj();
      }
    },
    init_fz: function () {
      if (this.aa.id) {
        this.init_spjs();
      } else {
        this.init_spjs();
        this.sphj();
      }
    },
    sphj: function () {
      let dt = [];
      if (aa.sphj) {
        for (var i = 0; i < aa.sphj; i++) {
          dt.push({ spbz_mc: "终审", sp_js: "请选择" });
        }
      }
      this.tableData2 = dt;
    },
    reset() {
      location.reload();
    },
    save() {
      if (this.aa.xy_bz) {
        this.aa.xy_bz = "1";
      } else {
        this.aa.xy_bz = "0";
      }
      this.aa.spbz = this.$refs.xGrid.getTableData().tableData;
      if (this.aa.id) {
        this.$axios
          .post("api/system/lcsz/update-lcsz-first", this.aa)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message["success"](res.data.message);
              location.reload();
            } else {
              this.$message["error"](res.data.message);
            }
          });
      } else {
        this.$axios
          .post("api/system/lcsz/set-lcsz-first", this.aa)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message["success"](res.data.message);
              location.reload();
            } else {
              this.$message["error"](res.data.message);
            }
          });
      }
    },
    init_tree() {
      this.$axios.get("api/system/lcsz/get-lcsz-lcmc").then((res) => {
        let self = this;
        self.tableData = res.data.map((item) => {
          return { id: item.lcdy_id, name: item.lcdy_mc };
        });
      });
    },
    sel: function (row) {
      this.aa.id = row.row.id;
      this.$axios
        .get("api/system/lcsz/get-lcsz-first?lcdy_id=" + row.row.id)
        .then((res) => {
          let xjlx = [];
          res.data.mx.map((item) => {
            if (!xjlx.includes(item.xjlx_dm)) {
              xjlx.push(item.xjlx_dm);
            }
          });
          this.aa.xjlx = xjlx;
          let sykh = [];
          res.data.mx.map((item) => {
            if (!sykh.includes(item.khbh)) {
              this.aa.sykh = item.khbh;
            }
          });
          this.aa.dq = res.data.mx[0]["dq"];
          this.aa.fz = res.data.mx[0]["fz"];
          // this.aa.sykh = sykh;
          this.aa.lcmc = res.data.data.lcdy_mc;
          this.aa.sphj = res.data.data.sphj;
          if (res.data.data.xy_bz == 1) {
            this.aa.xy_bz = true;
          } else {
            this.aa.xy_bz = false;
          }
          this.aa.state = res.data.data.state;
          if (res.data.data.state == 1) {
            this.showGroup = false;
          }
          if (res.data.data.state == 2) {
            this.showGroup = true;
          }
          this.tableData2 = res.data.bz;
        });
    },
    activeCellMethod({ column, columnIndex }) {
      if (columnIndex === 0) {
        return false;
      }
      return true;
    },
    editDisabledEvent({ row, column }) {
      alert("禁止编辑");
    },
    change() {
      if (this.aa.state == 1) {
        this.showGroup = false;
      }
      if (this.aa.state == 2) {
        this.showGroup = true;
      }
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/view/xtgl/splc/lcsz.vue